<template>
    <div class="mass-replacement-sentence">
        <Spinner v-if="replacement._replacing" style="z-index: 1499;" />
        <div class="mass-replacement-sentence__diff-list">
            <span
                v-for="(d, idx) in diff"
                :key="idx"
                class="mass-replacement-sentence__diff"
                :class="{
                    'mass-replacement-sentence__diff--added': d.added,
                    'mass-replacement-sentence__diff--removed': d.removed
                }"
                v-text="d.value"
            />
        </div>
        <div v-if="showActions" class="mass-replacement-sentence__actions">
            <button
                v-t="'massReplacement.buttons.replace'"
                class="button"
                @click.prevent="replace"
            ></button>
        </div>
    </div>
</template>

<script>
import { diffWords } from 'diff';

export default {
    name: 'MassReplacementSentence',
    props: {
        replacement: {
            type: Object,
            required: true
        },
        diffMode: Boolean,
        showActions: Boolean
    },
    computed: {
        diff() {
            const { replace_string, ssml_text } = this.replacement;
            return diffWords(ssml_text, replace_string).filter(
                d => !d[this.diffMode ? 'remove' : 'added']
            );
        }
    },
    methods: {
        replace() {
            this.$emit('replace', this.replacement);
        }
    }
};
</script>

<style lang="scss" src="./MassReplacementSentence.scss"></style>
